import type { Context, Petition, Template } from './types';
import { useFlyerTemplates } from './useFlyerTemplates';

type UseDownloadFlyerModalBodyArgs = { petition: Petition; context: Context };
type UseDownloadFlyerModalBodyReturn = ModelHookResult<{ templates: Template[] }>;
export function useDownloadFlyerModalBody({
	petition,
	context,
}: UseDownloadFlyerModalBodyArgs): UseDownloadFlyerModalBodyReturn {
	const templates = useFlyerTemplates({ petition, context });

	return { data: { templates } };
}
